/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReceiptItemDto } from './ReceiptItemDto';
import {
    ReceiptItemDtoFromJSON,
    ReceiptItemDtoFromJSONTyped,
    ReceiptItemDtoToJSON,
} from './ReceiptItemDto';

/**
 * 
 * @export
 * @interface GenerateReceiptDto
 */
export interface GenerateReceiptDto {
    /**
     * ID badania
     * @type {string}
     * @memberof GenerateReceiptDto
     */
    examId: string;
    /**
     * Metoda płatności
     * @type {string}
     * @memberof GenerateReceiptDto
     */
    paymentMethod: GenerateReceiptDtoPaymentMethodEnum;
    /**
     * Pozycje paragonu
     * @type {Array<ReceiptItemDto>}
     * @memberof GenerateReceiptDto
     */
    items: Array<ReceiptItemDto>;
    /**
     * Zapłacono
     * @type {string}
     * @memberof GenerateReceiptDto
     */
    paid?: string;
    /**
     * Typ paragonu
     * @type {string}
     * @memberof GenerateReceiptDto
     */
    receiptType: GenerateReceiptDtoReceiptTypeEnum;
    /**
     * URL API drukarki fiskalnej (klucz zbuforowanego tokenu drukarki)
     * @type {string}
     * @memberof GenerateReceiptDto
     */
    printerUrl: string;
}


/**
 * @export
 */
export const GenerateReceiptDtoPaymentMethodEnum = {
    Cash: 'Cash',
    BankTransfer: 'BankTransfer',
    Card: 'Card',
    Mobile: 'Mobile'
} as const;
export type GenerateReceiptDtoPaymentMethodEnum = typeof GenerateReceiptDtoPaymentMethodEnum[keyof typeof GenerateReceiptDtoPaymentMethodEnum];

/**
 * @export
 */
export const GenerateReceiptDtoReceiptTypeEnum = {
    Fiscal: 'Fiscal',
    EFiscal: 'EFiscal'
} as const;
export type GenerateReceiptDtoReceiptTypeEnum = typeof GenerateReceiptDtoReceiptTypeEnum[keyof typeof GenerateReceiptDtoReceiptTypeEnum];


/**
 * Check if a given object implements the GenerateReceiptDto interface.
 */
export function instanceOfGenerateReceiptDto(value: object): value is GenerateReceiptDto {
    if (!('examId' in value) || value['examId'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('receiptType' in value) || value['receiptType'] === undefined) return false;
    if (!('printerUrl' in value) || value['printerUrl'] === undefined) return false;
    return true;
}

export function GenerateReceiptDtoFromJSON(json: any): GenerateReceiptDto {
    return GenerateReceiptDtoFromJSONTyped(json, false);
}

export function GenerateReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateReceiptDto {
    if (json == null) {
        return json;
    }
    return {
        
        'examId': json['examId'],
        'paymentMethod': json['paymentMethod'],
        'items': ((json['items'] as Array<any>).map(ReceiptItemDtoFromJSON)),
        'paid': json['paid'] == null ? undefined : json['paid'],
        'receiptType': json['receiptType'],
        'printerUrl': json['printerUrl'],
    };
}

export function GenerateReceiptDtoToJSON(value?: GenerateReceiptDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'examId': value['examId'],
        'paymentMethod': value['paymentMethod'],
        'items': ((value['items'] as Array<any>).map(ReceiptItemDtoToJSON)),
        'paid': value['paid'],
        'receiptType': value['receiptType'],
        'printerUrl': value['printerUrl'],
    };
}

